<script setup>
import homeImageUrl from '@/assets/home.png'
</script>

<template>
  <main>
    <v-container fluid>
      <v-img class="mx-auto" max-width="600" :src="homeImageUrl"></v-img>
    </v-container>
  </main>
</template>
